import {
    ensureItemsModalState,
    clearSearchTimer,
    escapeRegExp,
    SEARCH_DEBOUNCE_MS,
} from './state.js';

export function handleItemsSearchInput(event) {
    const state = ensureItemsModalState(this);
    state.searchTerm = event.target.value.trim();

    const clearBtn = document.getElementById('clear-search');
    if (state.searchTerm) {
        clearBtn?.classList.remove('hidden');
    } else {
        clearBtn?.classList.add('hidden');
    }

    clearSearchTimer(state);
    state.searchTimer = setTimeout(() => {
        this.performItemsSearch(state.searchTerm);
    }, SEARCH_DEBOUNCE_MS);
}

export function handleItemsSearchKeydown(event) {
    if (event.key === 'Enter') {
        event.preventDefault();
        const state = ensureItemsModalState(this);
        clearSearchTimer(state);
        this.performItemsSearch(state.searchTerm);
    }

    if (event.key === 'Escape') {
        event.preventDefault();
        this.clearSearch();
    }
}

export function handleClearSearch() {
    this.clearSearch();
}

export function performItemsSearch(term) {
    const state = ensureItemsModalState(this);
    const normalizedTerm = term.toLowerCase();

    if (!state.collection) {
        return;
    }

    if (!normalizedTerm) {
        state.filteredItems = [...state.items];
        this.renderCollectionItems(state.items, state.collection);
        this.hideSearchResultsInfo();
        this.hideNoResultsState();
        this.updateItemsAfterMutation();
        return;
    }

    const filtered = state.items.filter((item) => {
        const searchFields = [
            item.project_name,
            item.post_title,
            item.title,
            item.name,
        ];

        return searchFields
            .filter(Boolean)
            .some((value) => String(value).toLowerCase().includes(normalizedTerm));
    });

    state.filteredItems = filtered;
    this.renderCollectionItems(filtered, state.collection);
    this.updateSearchResultsInfo(filtered.length);

    if (filtered.length === 0) {
        this.showNoResultsState(term);
    } else {
        this.hideNoResultsState();
        this.applySearchHighlight(term);
    }

    this.updateItemsAfterMutation();
}

export function updateSearchResultsInfo(count) {
    const info = document.getElementById('search-results-info');
    const number = document.getElementById('results-count');
    if (!info) {
        return;
    }

    info.classList.remove('hidden');
    if (number) {
        number.textContent = count;
    }
}

export function hideSearchResultsInfo() {
    const info = document.getElementById('search-results-info');
    info?.classList.add('hidden');
}

export function applySearchHighlight(term) {
    if (!term) {
        this.clearHighlights();
        return;
    }

    const state = ensureItemsModalState(this);
    const regex = new RegExp(escapeRegExp(term), 'gi');

    state.cachedElements.forEach(({ element }) => {
        const titleElement = element.querySelector('h3');
        if (!titleElement) {
            return;
        }

        const original = titleElement.dataset.originalTitle || titleElement.textContent || '';
        titleElement.innerHTML = original.replace(regex, (match) => `<mark class="bg-yellow-200">${match}</mark>`);
    });
}

export function clearHighlights() {
    const state = ensureItemsModalState(this);
    state.cachedElements.forEach(({ element }) => {
        const titleElement = element.querySelector('h3');
        if (!titleElement) {
            return;
        }

        const original = titleElement.dataset.originalTitle || titleElement.textContent || '';
        titleElement.textContent = original;
    });
}

export function showNoResultsState(term) {
    const listContainer = document.getElementById('items-list');
    if (!listContainer) {
        return;
    }

    this.hideNoResultsState();

    const wrapper = document.createElement('div');
    wrapper.className = 'no-search-results p-8 text-center text-gray-600';
    wrapper.innerHTML = `
        <svg class="w-12 h-12 mx-auto mb-4 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0z" />
        </svg>
        <h3 class="text-lg font-semibold text-gray-900 mb-1">Không tìm thấy kết quả</h3>
        <p class="text-sm text-gray-500">
            Không có dự án nào phù hợp với từ khóa "<strong>${this.escapeHtml(term)}</strong>"
        </p>
    `;

    listContainer.appendChild(wrapper);
}

export function hideNoResultsState() {
    document.querySelector('.no-search-results')?.remove();
}

export function clearSearch() {
    const state = ensureItemsModalState(this);
    state.searchTerm = '';
    clearSearchTimer(state);

    const searchInput = document.getElementById('search-items-input');
    const clearBtn = document.getElementById('clear-search');
    if (searchInput) {
        searchInput.value = '';
    }
    clearBtn?.classList.add('hidden');

    this.performItemsSearch('');
}

export function resetItemsSearchUI() {
    const state = ensureItemsModalState(this);
    state.searchTerm = '';
    const searchInput = document.getElementById('search-items-input');
    const clearBtn = document.getElementById('clear-search');
    if (searchInput) {
        searchInput.value = '';
    }
    clearBtn?.classList.add('hidden');
    this.hideSearchResultsInfo();
    this.hideNoResultsState();
    this.clearHighlights();
}

